import { alpha, Box, Divider, Stack, Typography, useTheme } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"

export function SimilaritySelectionSummaryValue({ selectedCount = 0, schedulesCount = 0 }) {
    const theme = useTheme()
    const color = theme.palette.primary.main

    return (
        <Box
            sx={{
                display: "grid",
                gridTemplateColumns: "1fr auto 1fr",
                alignItems: "center",
                minWidth: 0,
                minHeight: 72,
                height: "100%",
                p: 1.5,
                border: "1px solid",
                borderColor: "divider",
                borderRadius: 1.5,
                bgcolor: "action.hover",
            }}
        >
            <Stack direction="row" spacing={1.5} alignItems="center" minWidth={0}>
                <Box
                    sx={{
                        display: "grid",
                        placeItems: "center",
                        width: 40,
                        height: 40,
                        flexShrink: 0,
                        borderRadius: "50%",
                        color,
                        bgcolor: alpha(color, 0.12),
                    }}
                >
                    <Iconify icon="mdi:checkbox-multiple-marked-outline" width={22} />
                </Box>
                <Box minWidth={0} data-cy="selected-count">
                    <Typography variant="h5" lineHeight={1}>
                        {selectedCount}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" noWrap>
                        {"Task".pluralize(selectedCount)} selected
                    </Typography>
                </Box>
            </Stack>
            <Divider orientation="vertical" />
            <Box minWidth={0} sx={{ pl: 3 }} data-cy="affected-schedules-count">
                <Typography variant="h5" lineHeight={1}>
                    {schedulesCount}
                </Typography>
                <Typography variant="body2" color="text.secondary" noWrap>
                    Parent {"Schedule".pluralize(schedulesCount)}
                </Typography>
            </Box>
        </Box>
    )
}
